module.exports = "data:image/gif;base64,R0lGODlhBwANAMQAAEBIYHB4kEBQcFBggGBwkHCAoKWsurzBy9LV28LL1bzDyzBIYEBYcFBogGB4kEBQYHCIoFBgcGBwgHCAkLC5wsfN08LIztLV2N7h5NLX2/////X19f///wAAAAAAAAAAACH5BAEAABwALAAAAAAHAA0AAAU7ICeOZGmKCQRNlgglnDUV3MQRnEQHN9c4Oc6Aw2hwIhwB58FIGgCcBSNzeFwQC4WgwsEIDpzKYvGgcEIAOw=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/grid/attachment.gif
// module id = Yf5h
// module chunks = 1